import { Button, cn } from '@sunstone/ui';
import { Plus } from 'lucide-react';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 text-center animate-in fade-in zoom-in duration-500',
        className,
      )}
    >
      <div className="bg-muted/30 rounded-full p-4 mb-4 ring-1 ring-border/50">{icon}</div>
      <h3 className="font-semibold text-lg mb-2 text-foreground">{title}</h3>
      <p className="text-muted-foreground text-sm max-w-xs mb-6 leading-relaxed text-balance">
        {description}
      </p>
      {actionLabel && onAction && (
        <Button variant="outline" onClick={onAction} className="gap-2 group">
          <span className="group-hover:text-primary transition-colors">{actionLabel}</span>
          <Plus className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors" />
        </Button>
      )}
    </div>
  );
}
